import React from 'react';
import { Button } from 'antd';
import intl from 'react-intl-universal';
import styles from 'views/Payout/components/Body/components/PayoutDetails/components/PayoutDetailCard/PayoutDetailCard.module.css';
import OwnerPayoutCardView from './OwnerPayoutCardView';

const ReportingCard = ({ card, record, pdfLoading, onAudit, onUnaudit, onPay, onUnpay, onPdf }) => {
  const audited = String(card && card.auditStatus) === 'audited';
  const paid = String(card && card.paymentStatus) === 'paid';
  const extraActions = [
    audited ? (
      <span key="audit" className={styles.actionLink} onClick={() => onUnaudit && onUnaudit(record)}>
        Unaudit
      </span>
    ) : (
      <span key="audit" className={styles.actionLink} onClick={() => onAudit && onAudit(record)}>
        Audit
      </span>
    ),
    paid ? (
      <span key="pay" className={styles.actionLink} onClick={() => onUnpay && onUnpay(record)}>
        Mark Unpaid
      </span>
    ) : (
      <span key="pay" className={styles.actionLink} onClick={() => onPay && onPay(record)}>
        Mark Paid
      </span>
    ),
  ];

  return (
    <OwnerPayoutCardView
      card={card}
      shouldShowEarning
      extraActions={extraActions}
      invoice={
        <Button type="primary" loading={!!pdfLoading} onClick={() => onPdf && onPdf(record)}>
          {intl.get('payout.headerLabels.invoicePayout').d('Invoice Payout')}
        </Button>
      }
    />
  );
};

export default ReportingCard;
